import React from 'react';
import { PostCommentDto } from 'src/api/FiretrolApiClient';
import {
  useDeletePostComment,
  useUpdatePostComment,
} from 'src/api/queries/posts/usePostCommentMutations';
import { useAuth } from 'src/hooks/useAuth';
import { CommentInput } from 'src/design/molecules/CommentInput';

interface CommentValueProps {
  comment: PostCommentDto;
  jobId: number;
}

export const CommentValue: React.FC<CommentValueProps> = ({
  comment,
  jobId,
}) => {
  const { user } = useAuth();
  const postId = comment.postId ?? '';
  const updateComment = useUpdatePostComment(jobId, postId);
  const deleteComment = useDeletePostComment(jobId, postId);

  // CommentInput only leaves edit mode when its save resolves, so a failed
  // save has to reject rather than swallow the error.
  const handleUpdate = async (newComment: PostCommentDto) => {
    await updateComment.mutateAsync({
      commentId: comment.id,
      comment: newComment.comment ?? '',
    });
  };

  const handleDelete = async () => {
    await deleteComment.mutateAsync(comment.id);
  };

  return (
    <CommentInput
      comment={comment}
      onCommentUpdate={handleUpdate}
      onCommentDelete={handleDelete}
      currentUserId={user?.id}
    />
  );
};
